import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { PotenzaHero } from '../components/potenza/PotenzaHero';
export function PotenzaPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2600">
      <Navigation data-id="element-2601" />
      <main data-id="element-2602">
        <PotenzaHero data-id="element-2603" />
      </main>
      <Footer data-id="element-2604" />
    </div>;
}